module.exports = __webpack_public_path__ + "img/langtransportert_med_paavirkningsgrad.28435582.jpg";